export default {
    cities: 'شهرها',
    citiesTitle: 'عنوان',
    citiesStatus: 'وضعیت',
    editCities: 'ویرایش شهر ها ',
    addCities: 'شهر جدید',
    provinces: 'جست و جو براساس استان',
    provincesTitle: 'استان ها',
    province: 'استان ها',
}